function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Instagram Copy");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "All-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Home---1820x1024",
  transform: "translate(-1549.000000, -175.000000)",
  fill: "#F61C0D"
}, React.createElement("g", {
  id: "Popup-Copy",
  transform: "translate(1530.000000, 84.000000)"
}, React.createElement("g", {
  id: "Icons/Youtube",
  transform: "translate(16.000000, 86.000000)"
}, React.createElement("g", {
  id: "youtube",
  transform: "translate(3.000000, 5.000000)"
}, React.createElement("path", {
  d: "M11.0683939,0.0120183486 L2.90133333,0.0120183486 C1.2989697,0.0120183486 0,1.3229052 0,2.93996942 L0,7.06009174 C0,8.67715596 1.2989697,9.98804281 2.90133333,9.98804281 L11.0683939,9.98804281 C12.6707576,9.98804281 13.9697273,8.67715596 13.9697273,7.06009174 L13.9697273,2.93996942 C13.9697273,1.3229052 12.6707576,0.0120183486 11.0683939,0.0120183486 Z M9.10624242,5.2004893 L5.28624242,7.03911315 C5.18445455,7.08810398 5.06687879,7.01321101 5.06687879,6.89941896 L5.06687879,3.10724771 C5.06687879,2.99183486 5.18754545,2.91703364 5.28954545,2.96920489 L9.10954545,4.92275229 C9.22312121,4.98082569 9.22115152,5.14519878 9.10624242,5.2004893 Z",
  id: "Shape",
  fillRule: "nonzero"
}))))));

var SvgYoutube = function SvgYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "10px",
    viewBox: "0 0 14 10",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube.c826eb6c.svg";
export { ForwardRef as ReactComponent };